const userReducer = (
  state = {
    loggedIn: false,
    notifications: '',
    userName: '',
    isUserRepack: false
  },
  action
) => {
  switch (action.type) {
    case 'LOG_IN':
      return { ...state, loggedIn: true };
    case 'LOG_OUT':
      return { ...state, loggedIn: false };
    case 'SET_NOTIFICATIONS':
      return { ...state, notifications: action.payload };
    case 'SET_LOGGED_IN_USER':
      return { ...state, userName: action.payload };
    case 'SET_USER_ORGANIZATION':
      return { ...state, userOrganization: action.payload };
    case 'SET_USER_REPACK':
      return { ...state, isUserRepack: action.payload };
    default:
      return state;
  }
};

export default userReducer;
